import { render, staticRenderFns } from "./sorgenteNew.vue?vue&type=template&id=405e417b&"
import script from "./sorgenteNew.vue?vue&type=script&lang=js&"
export * from "./sorgenteNew.vue?vue&type=script&lang=js&"
import style0 from "./sorgenteNew.vue?vue&type=style&index=0&id=405e417b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports